/* Arte Collective · Globe "Join the community" — aucune dépendance */
(function () {
  'use strict';
  if (window.console) console.info('[ac-globe] version 2026-10-09i');
  var LAND = {"S":1.1,"LA0":-56,"rows":[[],[59,1],[59,2],[60,2],[60,3],[61,4],[62,5],[64,5],[66,5],[67,4,219,2],[68,5,223,3],[70,6,229,2],[72,5,217,2,234,2],[73,5,221,2,239,2],[74,8,245,1],[75,8,249,2],[76,11,230,3,253,2],[77,12,231,8,257,1],[79,12,235,8,260,1],[81,11,236,1,238,9,263,1],[82,14,150,5,223,3,238,1,240,10],[83,15,152,7,226,7,240,14],[84,16,154,8,229,10,241,16],[85,17,155,10,231,29],[87,16,156,12,234,30],[87,18,158,12,236,31],[89,18,158,14,238,32],[89,19,159,15,240,32],[91,18,161,15,185,2,242,33],[91,20,162,17,186,3,244,32],[92,23,163,18,187,4,246,31],[93,25,164,18,189,4,249,30],[94,25,165,18,191,4,252,28,293,1],[94,26,166,19,193,3,258,23],[95,26,166,21,194,4,260,22],[95,28,167,22,195,4,262,21,310,1],[94,29,168,24,196,5,265,13,281,3],[92,32,169,25,200,3,268,10,283,3],[92,33,170,25,201,2,270,1,273,7,284,2,306,1],[92,34,171,25,203,1,275,6,285,2],[92,35,173,24,278,2,287,1],[92,36,173,24],[91,38,173,24,272,1,293,2],[92,39,175,23,265,2,268,5,275,2,289,3,294,2,298,1],[91,40,174,24,259,5,287,8],[90,41,174,24,258,3,288,8,303,1],[90,42,175,25,258,1,272,1,288,7,300,1],[90,39,174,25,257,2,272,1,274,1,286,9],[91,37,174,26,256,4,266,4,272,1,274,1,278,1,280,3,284,9],[91,33,173,28,254,1,256,3,264,6,272,2,284,2,289,1,297,1],[91,26,118,4,172,30,255,3,263,7,274,2,283,5],[91,28,172,31,254,4,263,8],[92,27,173,31,252,1,254,3,263,9,277,1,280,1],[93,25,173,33,253,2,257,1,265,6,280,1],[94,24,173,34,252,2,256,2,267,4],[93,24,156,1,169,1,172,35,250,2,255,2,267,4],[93,22,155,8,168,40,254,3,268,3],[93,18,153,54,235,2,253,2,275,1],[92,18,151,56,234,2,252,1,272,4],[87,5,93,14,150,57,231,1,234,1,250,2,256,1,267,1,274,1],[86,1,94,3,98,8,149,58,230,2,255,2,271,2],[85,1,95,2,98,2,147,53,203,4,229,3,249,1,253,5,267,1,270,1],[83,3,96,1,146,53,227,5,248,1,252,6,270,2],[81,5,105,1,145,52,198,2,226,4,246,2,249,7,266,1,268,1],[78,8,144,51,197,5,225,5,245,10,265,1],[76,8,143,50,195,8,223,5,244,9,263,1],[71,9,136,1,143,49,195,9,221,8,240,11,262,2],[68,12,143,47,193,11,220,9,238,11,261,1],[66,7,77,3,93,3,142,46,191,14,218,10,237,10,249,2],[21,1,64,8,77,3,88,1,141,45,189,15,217,11,235,10,248,1],[64,7,77,3,87,2,139,46,187,16,213,1,215,12,232,13],[63,7,84,2,138,45,185,17,210,18,229,18],[62,7,138,43,183,17,208,40,251,2],[57,1,61,8,137,42,181,11,195,2,205,42,249,1],[56,1,59,9,136,41,179,12,194,1,198,48],[55,1,58,10,80,2,136,39,177,11,193,52],[53,2,56,11,79,2,135,38,174,11,188,55],[53,1,55,13,78,2,135,48,185,56],[51,1,54,18,75,1,77,1,135,46,182,57],[50,1,53,24,133,22,157,79],[49,28,132,19,155,4,166,66,233,1,240,1],[48,29,131,15,164,65,236,3],[46,31,131,13,163,64,235,1,238,1],[44,33,129,1,133,9,151,3,158,1,161,62,228,2,232,6],[43,34,127,1,133,7,153,1,156,1,158,62,224,3,232,3],[42,33,124,5,140,1,146,1,148,1,150,16,169,47,217,1,222,2,231,1],[41,34,122,6,143,3,148,15,167,45,218,2,228,1],[40,35,120,6,128,1,132,1,141,2,145,16,164,46,212,1,214,2,225,1],[39,35,119,6,130,1,134,3,138,3,142,1,145,14,162,46,209,5,221,1],[38,37,117,8,128,1,131,2,136,5,145,1,151,4,159,52,217,1],[37,36,114,8,127,2,132,7,147,5,154,53,208,1,213,3],[37,36,75,1,117,6,124,2,128,9,143,6,151,56,210,2],[36,38,75,2,115,9,125,10,137,2,140,6,149,55],[36,38,75,1,113,23,137,7,147,53],[35,36,77,2,110,87,199,1],[34,33,68,2,74,3,106,87],[32,35,69,1,72,2,105,1,107,82,190,1],[30,40,71,1,101,2,105,80,186,1],[30,26,57,13,96,1,99,3,104,78,189,1],[28,27,56,12,94,6,102,74,184,2,193,1],[27,26,54,12,91,2,95,1,101,1,103,66,170,1,180,2],[9,1,27,24,53,10,90,3,98,2,105,59,165,1,175,3],[10,1,24,23,51,1,53,7,89,1,96,1,98,2,102,59,170,4],[11,1,13,1,22,22,51,8,86,2,95,2,101,57,166,3],[11,3,21,21,49,7,84,1,89,1,91,3,96,57,162,1],[9,4,19,21,48,3,53,1,86,6,95,57,153,2,158,1],[8,7,16,23,46,4,60,2,80,1,83,6,90,61,154,4],[7,31,44,3,57,3,80,6,87,59,147,1,149,4],[7,30,46,2,55,3,78,5,84,66],[8,28,38,1,43,4,52,4,63,3,76,5,82,5,88,56],[2,1,6,32,40,4,49,5,61,3,74,4,79,4,85,53],[0,4,5,30,40,2,43,1,47,7,72,8,82,51],[0,2,6,29,38,4,45,7,69,11,81,8,90,37],[0,1,5,18,24,2,29,2,32,1,35,3,43,8,66,8,76,1,78,43],[6,8,15,3,19,1,21,4,27,2,31,1,34,3,42,8,64,5,77,2,80,1,82,30,113,2],[6,3,21,3,26,1,28,6,40,6,62,2,75,28],[17,5,26,1,28,3,36,10,67,1,71,18,92,3],[15,9,25,2,34,9,63,1,68,1,71,13,87,1],[15,2,20,1,22,1,32,9,68,5],[16,1,20,4,29,9,56,1,63,7,78,1],[14,1,17,2,27,9,53,2,60,5,70,1],[19,2,23,10,56,1],[15,1,18,12,37,1],[13,1,15,3,20,8,33,1,47,1]]};
  var D2R = Math.PI / 180, R2D = 180 / Math.PI;
  var AC = [254, 96, 22], BG = [247, 247, 247];
  var HUBS = { WEST: [-119.8, 39.5], EAST: [-79.9, 35.8], NL: [5.1, 52.1], UK: [-1.4, 52.9] };
  var EU = 'FR DE IT ES NL BE AT PT IE LU DK SE FI PL CZ SK SI HR HU RO BG GR EE LV LT MT CY CH NO'.split(' ');

  function hubFor(country, lon) {
    if (country === 'GB') return HUBS.UK;
    if (EU.indexOf(country) > -1) return HUBS.NL;
    if (country === 'US' || country === 'CA') return lon < -100 ? HUBS.WEST : HUBS.EAST;
    return null;
  }
  function norm(a) { return ((a % 360) + 540) % 360 - 180; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cityOnly(n) { return String(n || '').split(',')[0]; }
  function niceName(n) { return String(n || '').replace(/, GB$/, ', UK'); }
  function ago(iso) {
    var h = (Date.now() - Date.parse(iso)) / 36e5;
    if (!(h >= 0)) return 'recently';
    if (h < 1) return 'just now';
    if (h < 48) return Math.floor(h) + 'h ago';
    return 'recently';
  }
  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  function rgba(a) { return 'rgba(' + AC[0] + ',' + AC[1] + ',' + AC[2] + ',' + Math.max(0, a).toFixed(3) + ')'; }
  var INK = [27, 27, 25];
  function mixInk(t) { return 'rgb(' + INK.map(function (v, i) { return Math.round(v * t + BG[i] * (1 - t)); }).join(',') + ')'; }
  function inkA(a) { return 'rgba(' + INK.join(',') + ',' + Math.max(0, a).toFixed(3) + ')'; }
  var DULL = [240, 140, 96];
  function dull(t) { return 'rgb(' + DULL.map(function (v, i) { return Math.round(v * t + BG[i] * (1 - t)); }).join(',') + ')'; }
  function mix(t) { return 'rgb(' + AC.map(function (v, i) { return Math.round(v * t + BG[i] * (1 - t)); }).join(',') + ')'; }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function vec(lon, lat) { var l = lon * D2R, p = lat * D2R; return [Math.cos(p) * Math.cos(l), Math.cos(p) * Math.sin(l), Math.sin(p)]; }
  function arcBetween(a, b) {
    var va = vec(a[0], a[1]), vb = vec(b[0], b[1]);
    var d = Math.acos(clamp(va[0] * vb[0] + va[1] * vb[1] + va[2] * vb[2], -1, 1));
    return {
      d: d,
      at: function (t) {
        if (d < 1e-6) return a;
        var s = Math.sin(d), k1 = Math.sin((1 - t) * d) / s, k2 = Math.sin(t * d) / s;
        var x = va[0] * k1 + vb[0] * k2, y = va[1] * k1 + vb[1] * k2, z = va[2] * k1 + vb[2] * k2;
        return [Math.atan2(y, x) * R2D, Math.asin(clamp(z, -1, 1)) * R2D];
      }
    };
  }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  var isSafari = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);
  if (isSafari && !document.getElementById('acg-safari-style')) {
    var st = document.createElement('style'); st.id = 'acg-safari-style';
    st.textContent = '.ac-globe .ac-gl{-webkit-backdrop-filter:none!important;backdrop-filter:none!important;background:rgba(255,255,255,.95)!important}' +
      '.ac-globe .ac-globe__card,.ac-globe .ac-globe__sheet{background:rgba(255,255,255,.97)!important}.ac-globe .ac-globe__dot{animation:none!important}';
    document.head.appendChild(st);
  }
  function Globe(root) {
    var cv = root.querySelector('.ac-globe__canvas'), ctx = cv.getContext('2d'), cctx = ctx;
    var ov = document.createElement('canvas');
    ov.setAttribute('aria-hidden', 'true');
    ov.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block;pointer-events:none';
    cv.parentNode.insertBefore(ov, cv.nextSibling);
    var octx = ov.getContext('2d');
    var rv = root.querySelector('.ac-globe__rings'), rctx = rv ? rv.getContext('2d') : null;
    var liveEl = root.querySelector('.ac-globe__live'), liveTxt = root.querySelector('.ac-globe__live-text');
    var pl = root.querySelector('.ac-globe__pin'), card = root.querySelector('.ac-globe__card'), sh = root.querySelector('.ac-globe__sheet');
    sh.style.maxHeight = 'calc(100% - 16px)';
    var walls = [];
    try { walls = JSON.parse(root.querySelector('.ac-globe__walls').textContent) || []; } catch (e) {}
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoTour = root.getAttribute('data-tour') !== 'false' && !reduce;
    var showLive = root.getAttribute('data-live') !== 'false';
    var interval = (parseFloat(root.getAttribute('data-interval')) || 4) * 1000;
    var dpr = Math.min(2, window.devicePixelRatio || 1);

    /* Grille des continents */
    var S = LAND.S, LA0 = LAND.LA0, rows = [], dots = [];
    LAND.rows.forEach(function (runs, r) {
      var la = LA0 + r * S, n = Math.round(360 * Math.cos(la * D2R) / S), m = {};
      for (var k = 0; k < runs.length; k += 2) for (var i = runs[k]; i < runs[k] + runs[k + 1]; i++) {
        var d = { lon: -180 + i * 360 / n, lat: la, c: 0, top: 0, name: null, walls: null, r: r, i: i, cl: Math.cos(la * D2R), sl: Math.sin(la * D2R) };
        m[i] = d; dots.push(d);
      }
      rows[r] = { n: n, m: m };
    });
    function snap(lon, lat) {
      var r0 = Math.round((lat - LA0) / S), best = null, bd = 9;
      for (var r = r0 - 1; r <= r0 + 1; r++) {
        var row = rows[r]; if (!row) continue;
        var i0 = Math.round((lon + 180) / 360 * row.n);
        for (var di = -2; di <= 2; di++) {
          var i = ((i0 + di) % row.n + row.n) % row.n, d = row.m[i]; if (!d) continue;
          var a = vec(lon, lat), b = vec(d.lon, d.lat), g = Math.acos(clamp(a[0] * b[0] + a[1] * b[1] + a[2] * b[2], -1, 1));
          if (g < bd) { bd = g; best = d; }
        }
      }
      return best;
    }

    var baseKey = '', dataV = 0, lastF = 0, lastHot = null, lastPulse = 0, forceDraw = true, slow = isSafari, cost = 0, frames = 0;
    var lit = [], byName = {}, cityCountry = {}, live = [];
    var mob, W, H, R, cx, cy, TY, HIT, Rk, cyk, cLon = -95, cLat = 18, zoom = 1;
    var tw = null, cur = null, pinned = false, hoverPin = false, dragging = false, idleUntil = 0, nextAt = 0, opened = false, leaveT = null;
    var order = [], arcs = [], flashes = [], running = false, raf = 0, ready = false;

    function size() {
      // Mobile : hauteur calculée pour le cas le plus haut (plusieurs clients + avis sur 2 lignes), selon la largeur de l'écran
      if (window.innerWidth < 750) root.style.height = Math.round(336 + (root.clientWidth - 44) * 7 / 16) + 'px';
      else root.style.height = '';
      W = cv.clientWidth; H = cv.clientHeight; if (!W || !H) return;
      cv.width = W * dpr; cv.height = H * dpr; cctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (rv) { rv.width = W * dpr; rv.height = H * dpr; rctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      ov.width = W * dpr; ov.height = H * dpr; octx.setTransform(dpr, 0, 0, dpr, 0, 0); baseKey = ''; forceDraw = true;
      mob = window.innerWidth < 750;
      // la planète commence sous le titre (TOP) et le recouvre légèrement
      if (mob) { R = W * 1.15; cy = H * 1.12; TY = H * .58; HIT = 14; } else { R = Math.min(W * .64, 460); cy = H * 1.02; TY = H * .58; HIT = 3; }
      cx = W / 2;
    }
    function P(lon, lat, cp, sp) {
      var dl = (lon - cLon) * D2R, p0 = cLat * D2R;
      if (cp === undefined) { cp = Math.cos(lat * D2R); sp = Math.sin(lat * D2R); }
      var cp0 = Math.cos(p0), sp0 = Math.sin(p0), cd = Math.cos(dl);
      return [cx + Rk * cp * Math.sin(dl), cyk - Rk * (cp0 * sp - sp0 * cp * cd), sp0 * sp + cp0 * cp * cd];
    }
    function gr(c) { return (mob ? .6 : .55) * (1 + c); }
    var cMax = 1, topSet = {}, maxR = 4;
    // Taille plafonnée à ~45 % de l'écart entre deux points de la grille : les points ne se chevauchent jamais
    function lr(d, c) {
      var rMin = gr(c) * 1.45, rMax = Math.max(rMin, maxR * (.55 + .45 * c));
      if (d.hub) {
        var hMin = maxR * .95 * (.6 + .4 * c), hMax = maxR * 1.6 * (.6 + .4 * c);
        return hMin + (hMax - hMin) * Math.sqrt(Math.max(0, d.c - thr) / Math.max(1, cMax - thr));
      }
      return rMin + (rMax - rMin) * Math.min(1, Math.sqrt(d.c / thr));
    }
    var thr = 20;
    function neighbors(d) {
      var out = [], a = vec(d.lon, d.lat);
      for (var r = d.r - 1; r <= d.r + 1; r++) {
        var row = rows[r]; if (!row) continue;
        var i0 = Math.round((d.lon + 180) / 360 * row.n);
        for (var di = -2; di <= 2; di++) {
          var n = row.m[((i0 + di) % row.n + row.n) % row.n]; if (!n || n === d) continue;
          var b = vec(n.lon, n.lat);
          if (Math.acos(clamp(a[0] * b[0] + a[1] * b[1] + a[2] * b[2], -1, 1)) < 1.2 * S * D2R) out.push(n);
        }
      }
      return out;
    }
    function own(d) { while (d && d.parent) d = d.parent; return d; }
    function heat(d) { return .64 + .36 * Math.log(1 + d.c) / Math.log(1 + cMax); }
    function goTo(lon, lat, instant) {
      var off = Math.asin(Math.min(.95, (cy - TY) / R)) * R2D;
      var tLat = clamp(lat - off, -30, 40), f0 = norm(cLon), dl = Math.abs(lon - f0);
      if (instant || reduce) { cLon = lon; cLat = tLat; tw = null; arrive(); return; }
      cLon = f0;
      tw = { from: [f0, cLat], to: [lon, tLat], t: Date.now(), dur: Math.max(900, 1500 + dl * 9), dip: Math.min(.3, dl / 360) };
    }
    function halo(x, y, r, a) {
      var g = ctx.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0, rgba(a)); g.addColorStop(.45, rgba(a * .55)); g.addColorStop(1, rgba(0));
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, 7); ctx.fill();
    }
    function rings(now) {
      var g = ctx, gap = mob ? 24 : 20;
      g.save(); g.lineWidth = .9; g.lineCap = 'round';
      [[1, [1.5, 5], .34], [2, [1.5, 6], .24], [3, [1.5, 7], .15]].forEach(function (o, i) {
        g.setLineDash(o[1]);
        g.strokeStyle = 'rgba(120,120,120,' + o[2] + ')';
        g.beginPath(); g.arc(cx, cyk, Rk + gap * o[0], Math.PI, 2 * Math.PI); g.stroke();
      });
      g.restore();
    }
    // Petits satellites en orbite sur les pointillés : [anneau, période (s), sens, phase]
    var SATS = [[1, 32, 1, .15], [2, 75, -1, .55, 'iss'], [3, 60, 1, .8, 'sputnik']];
    var t0sat = Date.now();
    // Spoutnik 1 : la sphère et ses 4 antennes en arrière
    function sputnik(g, a, ts, dir) {
      g.strokeStyle = '#8f949d'; g.lineWidth = .6; g.lineCap = 'round';
      [[-1.2, 11], [1.2, 11], [-3.2, 10], [3.2, 10]].forEach(function (an) {
        g.beginPath(); g.moveTo(0, 0); g.lineTo(-dir * an[1], an[0]); g.stroke();
      });
      g.beginPath(); g.arc(0, 0, 2.8, 0, 7); g.fillStyle = '#b9bdc5'; g.fill(); g.lineWidth = .6; g.stroke();
      g.beginPath(); g.arc(dir * .9, -.9, .9, 0, 7); g.fillStyle = '#e9ebef'; g.fill();
      var blink = .35 + .65 * Math.max(0, Math.sin(ts * 3.2));
      g.globalAlpha = a * blink; g.fillStyle = '#FE6016';
      g.beginPath(); g.arc(0, -4.2, .9, 0, 7); g.fill();
    }
    // La Station spatiale internationale, version miniature : poutre, 8 ailes solaires dorées, modules, radiateurs
    function iss(g, a, ts, k) {
      g.scale(.68, .68); g.lineWidth = .7;
      // ailes solaires (4 de chaque côté, au-dessus et en dessous de la poutre)
      [-14, -10.5, 10.5, 14].forEach(function (px) {
        [[-8.5, 7], [1.5, 7]].forEach(function (seg) {
          g.fillStyle = '#cdb67a'; g.strokeStyle = '#a8925a';
          g.fillRect(px - 1.3, seg[0], 2.6, seg[1]); g.strokeRect(px - 1.3, seg[0], 2.6, seg[1]);
          g.beginPath(); g.moveTo(px - 1.3, seg[0] + seg[1] / 2); g.lineTo(px + 1.3, seg[0] + seg[1] / 2); g.stroke();
        });
      });
      // poutre principale
      g.fillStyle = '#8f949d'; g.fillRect(-15.5, -.6, 31, 1.2);
      // radiateurs
      g.fillStyle = '#eef0f3'; g.strokeStyle = '#b7bcc4';
      [-6, 6].forEach(function (px) { g.fillRect(px - .8, 1.2, 1.6, 4); g.strokeRect(px - .8, 1.2, 1.6, 4); });
      // modules habités (croix au centre)
      g.fillStyle = '#a7acb5'; g.fillRect(-1.3, -6, 2.6, 12);
      g.fillStyle = '#8a8f99'; g.fillRect(-3.4, -1.4, 6.8, 2.8);
      g.fillStyle = '#c3c7ce'; g.fillRect(-1.3, -7.5, 2.6, 1.6);
      // balise
      var blink = .35 + .65 * Math.max(0, Math.sin(ts * 2.4 + k));
      g.globalAlpha = a * blink; g.fillStyle = '#FE6016';
      g.beginPath(); g.arc(0, -8.6, 1, 0, 7); g.fill();
    }
    function satellites(g, now, gap) {
      var ts = reduce ? 0 : (now - t0sat) / 1000;
      SATS.forEach(function (o, k) {
        // chaque satellite avance à vitesse constante sur son orbite ; il ne repart de l'autre côté
        // qu'une fois sorti du cadre (calculé avec la taille ACTUELLE de l'orbite) : jamais de saut visible, même pendant un dézoom
        var rr = Rk + gap * o[0], base = R + gap * o[0];
        var al0 = Math.asin(Math.min(1, (W / 2 + 30) / base)), alNow = Math.asin(Math.min(1, (W / 2 + 30) / rr));
        if (o.th === undefined) { o.th = 1.5 * Math.PI + o[2] * (-al0 + 2 * al0 * o[3]); o.t = now; }
        if (!reduce) { o.th += o[2] * (2 * al0 / o[1]) * Math.min(.1, (now - o.t) / 1000); }
        o.t = now;
        if (o[2] * (o.th - 1.5 * Math.PI) > alNow) o.th = 1.5 * Math.PI - o[2] * alNow;
        var th = o.th, sn = Math.sin(th), x = cx + rr * Math.cos(th), y = cyk + rr * sn;
        if (y < -12 || y > H + 12 || sn > -.02) return;
        var a = Math.min(1, -sn * 4);
        g.save(); g.globalAlpha = a; g.translate(x, y); g.rotate(th + Math.PI / 2);
        if (o[4] === 'iss') { iss(g, a, ts, k); g.restore(); return; }
        if (o[4] === 'sputnik') { sputnik(g, a, ts, o[2]); g.restore(); return; }
        // panneaux solaires
        g.fillStyle = '#c3c7ce'; g.strokeStyle = '#9aa0aa'; g.lineWidth = .6;
        g.fillRect(-9, -1.6, 5, 3.2); g.strokeRect(-9, -1.6, 5, 3.2);
        g.fillRect(4, -1.6, 5, 3.2); g.strokeRect(4, -1.6, 5, 3.2);
        g.beginPath(); g.moveTo(-6.5, -1.6); g.lineTo(-6.5, 1.6); g.moveTo(6.5, -1.6); g.lineTo(6.5, 1.6); g.stroke();
        // bras + corps
        g.fillStyle = '#9aa0aa'; g.fillRect(-4, -.4, 8, .8);
        g.fillStyle = '#7f848e'; g.fillRect(-2.2, -2.2, 4.4, 4.4);
        // petite balise orange qui clignote
        var blink = .35 + .65 * Math.max(0, Math.sin(ts * 3 + k * 2));
        g.globalAlpha = a * blink; g.fillStyle = '#FE6016';
        g.beginPath(); g.arc(0, -3.4, 1.1, 0, 7); g.fill();
        g.restore();
      });
    }

    function draw() {
      var now = Date.now(); zoom = 1;
      if (tw) {
        var f = (now - tw.t) / tw.dur;
        if (f >= 1) { cLon = tw.to[0]; cLat = tw.to[1]; tw = null; arrive(); }
        else { var e = ease(f); cLon = tw.from[0] + (tw.to[0] - tw.from[0]) * e; cLat = tw.from[1] + (tw.to[1] - tw.from[1]) * e; zoom = 1 - tw.dip * Math.sin(Math.PI * f); }
      }
      Rk = R * zoom; cyk = cy - (R - Rk) * .35; maxR = Rk * S * D2R * .44;
      var key = cLon.toFixed(3) + ',' + cLat.toFixed(3) + ',' + zoom.toFixed(4) + ',' + W + ',' + H + ',' + dataV;
      // calme (pas de vol, pas de trail) : 30 i/s suffisent pour les satellites et l'onde ; animations réduites : aucun rendu
      var hotNow = cur && cur.dot, quiet = key === baseKey && !arcs.length && !flashes.length && !tw && hotNow === lastHot && !forceDraw && !dragging;
      if (quiet && (reduce || now - lastPulse < 33)) return;
      lastHot = hotNow; forceDraw = false; lastPulse = now;
      if (key !== baseKey) { baseKey = key; ctx = cctx; ctx.clearRect(0, 0, W, H); rings(now); try {
      var g = ctx.createRadialGradient(cx - Rk * .3, cyk - Rk * .5, Rk * .1, cx, cyk, Rk);
      g.addColorStop(0, '#ffffff'); g.addColorStop(1, '#ebebeb');
      ctx.beginPath(); ctx.arc(cx, cyk, Rk, 0, 7); ctx.fillStyle = g; ctx.fill();
      ctx.strokeStyle = 'rgba(254,96,22,.08)'; ctx.lineWidth = 1; ctx.stroke();

      var NB = 6, bk = [], dz = Math.max(.75, zoom), i, d, p, c, r;
      for (i = 0; i < NB; i++) bk.push([]);
      for (i = 0; i < dots.length; i++) {
        d = dots[i]; if (d.c) continue; p = P(d.lon, d.lat, d.cl, d.sl); c = p[2];
        if (c < .04 || p[1] > H + 4 || p[0] < -4 || p[0] > W + 4) continue;
        bk[Math.min(NB - 1, Math.floor(c * NB))].push(p[0], p[1], gr(c) * dz);
      }
      ctx.fillStyle = '#7f848e';
      for (var b = 0; b < NB; b++) {
        ctx.globalAlpha = .16 + .62 * (b + .5) / NB; ctx.beginPath();
        var a = bk[b];
        for (i = 0; i < a.length; i += 3) { ctx.moveTo(a[i] + a[i + 2], a[i + 1]); ctx.arc(a[i], a[i + 1], a[i + 2], 0, 6.29); }
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      for (i = 0; i < lit.length; i++) {
        d = lit[i]; p = P(d.lon, d.lat, d.cl, d.sl); c = p[2];
        d.vis = c > .12 && p[1] < H - 6 && p[1] > 50 && p[0] > 0 && p[0] < W;
        if (c < .04) continue;
        r = lr(d, c) * dz; var fd = .35 + .65 * c; d.x = p[0]; d.y = p[1]; d.r = r;
        d.cc = c;
        if (d.walls) r = Math.max(r, maxR * 1.25 * (.6 + .4 * c));
        if (d.walls && topSet[d.lon + ',' + d.lat]) { ctx.globalAlpha = fd; halo(p[0], p[1], r * 2, .42); ctx.globalAlpha = 1; }
        ctx.beginPath(); ctx.arc(p[0], p[1], r, 0, 7); ctx.fillStyle = d.walls ? mix(fd) : dull(fd * (.65 + .35 * heat(d))); ctx.fill();
      }
      } finally { ctx = octx; } }
      ctx = octx; ctx.clearRect(0, 0, W, H);
      satellites(ctx, now, mob ? 24 : 20);
      if (cur && cur.dot && cur.dot.vis) {
        var hd = cur.dot, ha = .35 + .65 * (hd.cc || 1);
        ctx.globalAlpha = ha;
        halo(hd.x, hd.y, (hd.r * 2 + 4) * (reduce || mob ? 1 : 1 + .08 * Math.sin(now / 700)), .65); ctx.globalAlpha = 1;
        if (!reduce && !tw) {
          var pf = (now % 1600) / 1600;
          ctx.beginPath(); ctx.arc(hd.x, hd.y, hd.r + (hd.r * 2.2 + 8) * pf, 0, 7);
          ctx.strokeStyle = rgba(.55 * (1 - pf)); ctx.lineWidth = 1.5; ctx.setLineDash([]); ctx.stroke();
        }
        ctx.beginPath(); ctx.arc(hd.x, hd.y, hd.r, 0, 7); ctx.fillStyle = hd.walls ? mix(ha) : dull(ha * (.65 + .35 * heat(hd))); ctx.fill();
      }
      arcs = arcs.filter(function (A) {
        var f = (now - A.t) / A.dur; if (f > 1.35) return false;
        if (f >= 1 && !A.done) { A.done = true; flashes.push({ p: A.to, t: now }); }
        var hd = Math.min(1, f), tl = Math.max(0, f - (A.tour ? .7 : .5)), N = A.tour ? 48 : 30, pv = null;
        for (var k = 0; k <= N; k++) {
          var u = tl + (hd - tl) * k / N, gp = A.sl.at(u), h = Math.sin(u * Math.PI) * A.h, q = P(gp[0], gp[1]);
          var sx = cx + (q[0] - cx) * (1 + h), sy = cyk + (q[1] - cyk) * (1 + h);
          var vi = q[2] > 0 || Math.hypot(sx - cx, sy - cyk) > Rk, ee = k / N;
          var al = Math.pow(ee, 1.6) * (f > 1 ? Math.max(0, 1 - (f - 1) / .35) : 1);
          if (pv && vi && pv.v) { ctx.beginPath(); ctx.moveTo(pv.x, pv.y); ctx.lineTo(sx, sy); ctx.strokeStyle = rgba(al * .95); ctx.lineWidth = .6 + 1.6 * ee; ctx.lineCap = 'round'; ctx.stroke(); }
          pv = { x: sx, y: sy, v: vi };
        }
        if (f < 1 && pv && pv.v) { halo(pv.x, pv.y, 7, .5); ctx.beginPath(); ctx.arc(pv.x, pv.y, 1.8, 0, 7); ctx.fillStyle = mix(1); ctx.fill(); }
        return true;
      });
      flashes = flashes.filter(function (F) {
        var f = (now - F.t) / 1200; if (f > 1) return false;
        var q = P(F.p[0], F.p[1]); if (q[2] < .05) return true;
        halo(q[0], q[1], 6 + f * 12, .6 * (1 - f)); return true;
      });
      var showB = cur && cur.dot && !tw && cur.dot.vis && !(opened && !mob);
      if (showB) { place(); pl.classList.add('is-on'); }
      else pl.classList.remove('is-on');
      if (opened && !mob && cur && cur.dot) placeCard();
    }
    function setPos(el, x, y) {
      x = Math.round(x * 2) / 2; y = Math.round(y * 2) / 2;
      if (el.__x === x && el.__y === y) return;
      el.__x = x; el.__y = y; el.style.left = x + 'px'; el.style.top = y + 'px';
    }
    var placed = null;
    function place() {
      var d = cur.dot, bw = pl.firstChild; if (!bw) return;
      if (!placed || placed.dot !== d || Math.abs(placed.x - d.x) + Math.abs(placed.y - d.y) > 40) {
        var w = bw.offsetWidth, h = bw.offsetHeight;
        var cover = function (top) {
          if (top < 50 || top + h > H - 4) return 99;
          var n = 0;
          for (var i = 0; i < lit.length; i++) {
            var o = lit[i]; if (!o.hub || !o.vis || o === d) continue;
            if (o.x > d.x - w / 2 - o.r && o.x < d.x + w / 2 + o.r && o.y > top - o.r && o.y < top + h + o.r) n++;
          }
          return n;
        };
        var up = cover(d.y - d.r - 15 - h), down = cover(d.y + d.r + 15);
        placed = { dot: d, x: d.x, y: d.y, below: down < up };
        var svg = bw.querySelector('.ac-globe__ar');
        if (placed.below) {
          bw.style.animation = 'none'; bw.style.transform = 'translate(-50%, 15px)';
          if (svg) { svg.style.bottom = 'auto'; svg.style.top = '-8px'; svg.style.transform = 'translateX(-50%) rotate(180deg)'; }
        } else {
          bw.style.animation = ''; bw.style.transform = '';
          if (svg) { svg.style.top = ''; svg.style.bottom = '-8px'; svg.style.transform = 'translateX(-50%)'; }
        }
      }
      setPos(pl, d.x, placed.below ? d.y + d.r : d.y - d.r);
    }
    function loop(ts) {
      if (!running) return; raf = requestAnimationFrame(loop);
      if (slow && ts - lastF < 32) return;
      lastF = ts;
      var t0 = performance.now(); draw(); var dt = performance.now() - t0;
      // on n'évalue qu'après les premières images, et on peut revenir à 60 i/s si ça redevient fluide
      if (dt > 1 && ++frames > 90) { cost = cost * .92 + dt * .08; if (!slow && cost > 24) slow = true; else if (slow && !isSafari && cost < 12) slow = false; }
    }
    function start() { if (running || !ready) return; running = true; raf = requestAnimationFrame(loop); }
    function stop() { running = false; cancelAnimationFrame(raf); }

    function placeCard() {
      var d = cur.dot, cw = card.offsetWidth || 290, ch = card.offsetHeight, left = d.x + 26;
      if (left + cw > W - 12) left = d.x - 26 - cw;
      var cl = Math.max(12, left);
      var navH = nav.style.display === 'flex' ? 40 : 0, top = Math.min(H - ch - 12 - navH, Math.max(58, d.y - ch / 2));
      setPos(card, cl, top);
      if (navH) { setPos(nav, cl, top + ch + 4); if (nav.__w !== cw) { nav.__w = cw; nav.style.width = cw + 'px'; } }
    }
    function launch(dot, country, dur) {
      if (reduce || !dot) return;
      var from = hubFor(country, dot.lon); if (!from) return;
      var to = [dot.lon, dot.lat], sl = arcBetween(from, to);
      if (sl.d < .01) return;
      arcs.push({ to: to, sl: sl, t: Date.now(), dur: dur || 1100 + sl.d * 2400, h: clamp(.1 + sl.d * .5, .1, .38) });
    }
    function launchFrom(from, dot, dur) {
      if (reduce || !dot) return;
      var to = [dot.lon, dot.lat], sl = arcBetween(from, to);
      if (sl.d < .01) return;
      arcs.push({ to: to, sl: sl, t: Date.now(), dur: dur, h: clamp(.18 + sl.d * .6, .18, .6), tour: true });
    }
    function sold(n) { return '<b>' + fmt(n) + '</b> print' + (n > 1 ? 's' : '') + ' sold'; }
    function stack(list) {
      var k = Math.min(3, list.length), rots = [-6, 0, 6], s = '', IW = 48, IH = 60, OFF = 10;
      for (var i = k - 1; i >= 0; i--) {
        var rr = k === 1 ? 0 : rots[3 - k + i];
        s += '<img class="ac-globe__stk-img" src="' + esc(list[i].thumb) + '" alt="" style="left:' + i * OFF + 'px;top:0;width:' + IW + 'px;height:' + IH + 'px;transform:rotate(' + rr + 'deg);z-index:' + (3 - i) + '">';
      }
      return '<span class="ac-globe__stk" style="width:' + (IW + (k - 1) * OFF) + 'px;height:' + IH + 'px">' + s + '</span>';
    }
    function bubble() {
      var L = cur.list, d = cur.dot, city = esc(cityOnly(d.name)), h, cls;
      var title = '<span class="ac-globe__b1" style="line-height:1.15">' + city + '</span>';
      var count = d.c > 1 || d.top ? '<span class="ac-globe__b2 ac-mono" style="margin-top:4px;line-height:1.2">' + sold(d.c) + '</span>' : '';
      if (L.length) {
        var rest = [L[cur.i]].concat(L.filter(function (x, i) { return i !== cur.i; })).filter(function (w) { return w.thumb; });
        var see = '<span style="display:flex;align-items:center;gap:4px;margin-top:4px;font-size:10px;font-weight:500;line-height:1.2;color:#FE6016">' +
          (L.length > 1 ? 'See ' + L.length + (L.every(function (w) { return w.author; }) ? ' customers' : ' photos') : 'See photo') +
          '<svg width="8" height="8" viewBox="0 0 10 10" aria-hidden="true"><path d="M3.5 1.5 7 5l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        cls = 'is-click'; h = (rest.length ? stack(rest) : '') + '<span>' + title + count + see + '</span>';
      } else { cls = 'is-text'; h = '<span>' + title + count + '</span>'; }
      pl.innerHTML = '<span class="ac-globe__bw"><span class="ac-globe__bb ac-gl ' + cls + '"' + (L.length ? ' role="button" tabindex="0" style="padding:5px 16px 5px 5px"' : '') + '>' + h + '</span>' +
        '<svg class="ac-globe__ar" aria-hidden="true" width="16" height="9" viewBox="0 0 16 9" style="position:absolute;left:50%;bottom:-8px;transform:translateX(-50%);display:block;overflow:visible;pointer-events:none">' +
        '<path d="M0 0 L8 8.5 L16 0 Z" fill="rgba(250,249,246,.94)"/><path d="M.5 .5 L8 8 L15.5 .5" fill="none" stroke="rgba(0,0,0,.09)" stroke-width="1"/></svg></span>';
      var bb = pl.querySelector('.ac-globe__bb');
      hoverPin = false; placed = null; forceDraw = true;
      bb.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hoverPin = true; clearTimeout(leaveT); } });
      bb.addEventListener('pointerleave', function () { hoverPin = false; });
      if (L.length) {
        bb.addEventListener('click', function (e) { e.stopPropagation(); openDetail(); });
        bb.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDetail(); } });
      }
    }
    // Photo verticale : affichée en entier, sur un fond flou de la même photo (rien n'est coupé)
    // Photo horizontale : recadrée, en respectant le point focal choisi dans Shopify
    function photoHTML(f, ar, alt) {
      if (f.portrait) return '<div class="ac-globe__ph" style="position:relative;overflow:hidden;aspect-ratio:' + ar + '">' +
        '<img src="' + esc(f.img) + '" alt="" aria-hidden="true" style="position:absolute;left:-10%;top:-10%;width:120%;height:120%;object-fit:cover;filter:blur(16px) saturate(1.1);opacity:.6">' +
        '<img src="' + esc(f.img) + '" alt="' + alt + '" style="position:relative;display:block;height:100%;width:auto;max-width:100%;margin:0 auto;object-fit:contain;box-shadow:0 0 14px rgba(0,0,0,.08)"></div>';
      return '<img class="ac-globe__ph" style="aspect-ratio:' + ar + (f.fp ? ';object-position:' + esc(f.fp) : '') + '" src="' + esc(f.img) + '" alt="' + alt + '">';
    }
    function chipLabel(w, i) { return w.author || (w.product && w.product.title) || ('Photo ' + (i + 1)); }
    function detailHTML() {
      var d = cur.dot, f = cur.list[cur.i], n = cur.list.length, city = esc(cityOnly(d.name)), h = '';
      h += '<span class="ac-globe__x" role="button" tabindex="0" aria-label="Close">&times;</span>';
      h += '<p class="ac-globe__ct" style="line-height:1.1">' + city + '</p>';
      if (d.top) h += '<p class="ac-globe__cc ac-mono" style="margin-top:3px">' + sold(d.c) + (d.hub ? ' in the area' : ' here') + '</p>';
      if (n > 1) {
        h += '<div style="display:flex;flex-wrap:wrap;gap:6px;margin:0 0 10px">';
        cur.list.slice(0, 8).forEach(function (w, i) {
          var on = i === cur.i;
          h += '<span class="ac-globe__t' + (on ? ' is-on' : '') + '" role="button" tabindex="0" data-i="' + i + '" aria-label="' + esc(chipLabel(w, i)) + '" style="opacity:1;display:inline-flex;align-items:center;gap:6px;padding:3px 10px 3px 3px;border-radius:999px;font-size:12px;line-height:1;cursor:pointer;' +
            (on ? 'border:1px solid #FE6016;background:rgba(254,96,22,.08);color:#1b1b19;' : 'border:1px solid rgba(0,0,0,.1);background:#fff;color:#6e6c66;') + '">' +
            '<img src="' + esc(w.thumb) + '" alt="" style="width:20px;height:20px;border-radius:50%;object-fit:cover;display:block">' + esc(chipLabel(w, i)) + '</span>';
        });
        h += '</div>';
      }
      var ratio = !mob ? '' : (n > 1 && f.quote ? '16 / 7' : (n > 1 || f.quote ? '16 / 8' : '16 / 10'));
      if (f.img) h += photoHTML(f, ratio || '16 / 10', esc((f.product ? f.product.title + ' ' : '') + 'on a customer\'s wall in ' + cityOnly(d.name)));
      if (f.quote) h += '<p class="ac-globe__q">\u201C' + esc(f.quote) + '\u201D</p>';
      var st = ''; for (var s = 0; s < (f.stars || 5); s++) st += '\u2605';
      if (f.author || f.quote) h += '<p class="ac-globe__who"' + (f.quote ? '' : ' style="margin-top:12px"') + '><span class="ac-globe__st">' + st + '</span>' + (f.author ? '&nbsp; ' + esc(f.author) : '') + '</p>';
      else h += '<div style="height:12px"></div>';
      if (f.product) h += '<div class="ac-globe__pr" style="margin:0 -14px;padding:10px 14px 0"><span>' + esc(f.product.title) + '</span><a href="' + esc(f.product.url) + '">Shop this print \u2192</a></div>';
      if (entries.length > 1 && mob) h += '<div style="display:flex;justify-content:space-between;gap:8px;margin-top:8px">' + navButtons() + '</div>';
      return h;
    }
    var NB = 'display:inline-flex;align-items:center;gap:6px;padding:9px 12px;border-radius:6px;font-family:\'Roboto Mono\',ui-monospace,monospace;font-size:11px;font-weight:500;letter-spacing:.04em;text-transform:uppercase;line-height:1;color:#6e6c66;cursor:pointer;';
    function navButtons() {
      return '<span class="ac-gl" role="button" tabindex="0" data-dir="-1" style="' + NB + (trailIdx > 0 ? '' : 'visibility:hidden;') + '">Previous</span>' +
        '<span class="ac-gl" role="button" tabindex="0" data-dir="1" style="' + NB + '">Next city</span>';
    }
    var nav = document.createElement('div');
    nav.style.cssText = 'position:absolute;z-index:5;display:none;justify-content:space-between;gap:8px;pointer-events:auto';
    root.appendChild(nav);
    function bindNav(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-dir]'), function (b) {
        function go(e) { e.stopPropagation(); browse(+b.getAttribute('data-dir')); }
        b.addEventListener('click', go);
        b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(e); } });
      });
    }
    function renderDetail() {
      var el = mob ? sh : card;
      el.innerHTML = (mob ? '<span class="ac-globe__gb"></span>' : '') + detailHTML();
      var x = el.querySelector('.ac-globe__x');
      x.addEventListener('click', function (e) { e.stopPropagation(); closeDetail(); });
      x.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeDetail(); } });
      bindNav(el);
      if (!mob && entries.length > 1) { nav.innerHTML = navButtons(); bindNav(nav); nav.style.display = 'flex'; } else nav.style.display = 'none';
      Array.prototype.forEach.call(el.querySelectorAll('.ac-globe__t'), function (t) {
        function pick(e) { e.stopPropagation(); cur.i = +t.getAttribute('data-i'); renderDetail(); bubble(); }
        t.addEventListener('click', pick);
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(e); } });
      });
      if (!mob) placeCard();
    }
    function openDetail() {
      if (!cur || !cur.list.length) return;
      cur.user = true; cur.t = Date.now();
      opened = true; pinned = true; hoverPin = false;
      if (!mob) { card.classList.add('is-on'); renderDetail(); } else { renderDetail(); sh.classList.add('is-on'); }
    }
    function closeDetail() {
      opened = false; pinned = false; browsing = false; forceDraw = true; nav.style.display = 'none'; card.classList.remove('is-on'); sh.classList.remove('is-on');
      nextAt = Math.max(nextAt, Date.now() + 1000);
    }
    card.addEventListener('mouseenter', function () { clearTimeout(leaveT); });
    function arrive() { if (!cur) return; bubble(); if (browsing) openDetail(); }

    var tourDots = [];
    // Prochain mur : jamais un des 6 derniers, en priorité ceux montrés il y a le plus longtemps,
    // et on écarte les trajets les plus courts
    var history = [], entries = [];
    function far(prev, list) {
      if (!prev || list.length < 2) return list;
      list.sort(function (a, b) { return arcBetween([prev.lon, prev.lat], [b.d.lon, b.d.lat]).d - arcBetween([prev.lon, prev.lat], [a.d.lon, a.d.lat]).d; });
      return list.slice(0, Math.max(1, Math.ceil(list.length * 2 / 3)));
    }
    function pickNext(prev) {
      var keep = Math.min(6, entries.length - 1), recent = history.slice(-keep);
      var pool = entries.filter(function (e) { return e.d !== prev && recent.indexOf(e) < 0; });
      if (!pool.length) pool = entries.filter(function (e) { return e.d !== prev; });
      if (!pool.length) pool = entries.slice();
      pool.sort(function (a, b) { return (a.w.__t || 0) - (b.w.__t || 0); });
      var fresh = far(prev, pool.slice(0, Math.max(1, Math.ceil(pool.length / 2))));
      return fresh[Math.floor(Math.random() * fresh.length)];
    }
    function preloadThumb(w) { if (w.thumb) (new Image()).src = w.thumb; }
    function preload(w) { if (w.thumb) (new Image()).src = w.thumb; if (w.img) (new Image()).src = w.img; }
    var browsing = false, trail = [], trailIdx = -1;
    function remember(e) { trail = trail.slice(0, trailIdx + 1); trail.push(e); if (trail.length > 30) trail.shift(); trailIdx = trail.length - 1; }
    function travelTo(e) {
      var prev = cur && cur.dot;
      e.w.__t = Date.now(); preload(e.w);
      cur = { dot: e.d, list: e.d.walls, i: Math.max(0, e.d.walls.indexOf(e.w)) };
      pl.classList.remove('is-on'); goTo(e.d.lon, e.d.lat);
      if (tw && prev && prev !== e.d) launchFrom([prev.lon, prev.lat], e.d, tw.dur);
      if (!tw) arrive();
    }
    function browse(dir) {
      var e;
      if (dir < 0) { if (trailIdx <= 0) return; trailIdx--; e = trail[trailIdx]; }
      else { e = pickNext(cur && cur.dot); history.push(e); if (history.length > 12) history.shift(); remember(e); }
      opened = false; nav.style.display = 'none'; card.classList.remove('is-on'); sh.classList.remove('is-on');
      browsing = true; pinned = true; travelTo(e);
    }
    function nextFeature() {
      if (!tourDots.length) return;
      if (!entries.length) return;
      var prev = cur && cur.dot, e = pickNext(prev), d = e.d;
      history.push(e); if (history.length > 12) history.shift(); remember(e);
      e.w.__t = Date.now(); preload(e.w);
      cur = { dot: d, list: d.walls, i: Math.max(0, d.walls.indexOf(e.w)) };
      pl.classList.remove('is-on'); goTo(d.lon, d.lat); nextAt = Date.now() + (tw ? tw.dur : 0) + interval;
      if (tw) { if (prev && prev !== d) launchFrom([prev.lon, prev.lat], d, tw.dur); else launch(d, d.country || countryOf(d.name), tw.dur); }
    }
    function focusDot(d) {
      if (opened) closeDetail();
      cur = { dot: d, list: d.walls || [], i: 0, user: true, t: Date.now() }; bubble(); pinned = true;
      if (cur.list.length) openDetail();
    }
    setInterval(function () {
      if (!running || !autoTour) return;
      if (cur && cur.user && !opened && Date.now() - cur.t > 3000) { cur.user = false; pinned = false; hoverPin = false; idleUntil = 0; nextAt = 0; }
      if (pinned || hoverPin || dragging || Date.now() < idleUntil) { nextAt = Math.max(nextAt, idleUntil); return; }
      if (Date.now() >= nextAt) nextFeature();
    }, 250);

    var li = 0;
    function nextLive() {
      if (!live.length) return;
      var it = live[li % live.length]; li++;
      liveTxt.style.opacity = 0; liveTxt.style.transform = 'translateY(-4px)';
      setTimeout(function () {
        liveTxt.innerHTML = 'Someone in <b>' + esc(cityOnly(it.city)) + '</b> ordered <b>' + esc(it.print) + '</b><em class="ac-mono" style="margin-left:8px">' + ago(it.at) + '</em>';
        liveTxt.style.opacity = 1; liveTxt.style.transform = 'none';
        var k = String(it.city).toLowerCase(); if (running) launch(own(byName[k]), it.country || cityCountry[k] || countryOf(it.city));
      }, 350);
      setTimeout(nextLive, 4500 + Math.random() * 2500);
    }
    function countryOf(label) {
      var m = /, ([A-Z]{2})$/.exec(label || ''); if (!m) return null;
      var c = m[1] === 'UK' ? 'GB' : m[1]; return EU.indexOf(c) > -1 || c === 'GB' ? c : 'US';
    }

    function hit(e) {
      var b = cv.getBoundingClientRect(), mx = e.clientX - b.left, my = e.clientY - b.top, best = null, bd = HIT;
      for (var i = 0; i < lit.length; i++) { var d = lit[i]; if (!d.vis) continue; var k = Math.hypot(d.x - mx, d.y - my) - (d.r || 0); if (k < bd) { bd = k; best = d; } }
      return best;
    }
    var sx, sy, sl0, sa0, mv;
    cv.addEventListener('pointerdown', function (e) { dragging = true; tw = null; mv = false; sx = e.clientX; sy = e.clientY; sl0 = cLon; sa0 = cLat; cv.setPointerCapture(e.pointerId); });
    cv.addEventListener('pointermove', function (e) {
      if (!dragging) { if (!mob && e.pointerType === 'mouse') cv.style.cursor = hit(e) ? 'pointer' : 'grab'; return; }
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!mv && Math.abs(dx) + Math.abs(dy) > 5) { mv = true; if (opened) closeDetail(); hoverPin = false; }
      cLon = sl0 - dx * .22; if (e.pointerType === 'mouse') cLat = clamp(sa0 + dy * .22, -30, 40);
    });
    function deselect() {
      if (opened) closeDetail();
      cur = null; pinned = false; hoverPin = false; forceDraw = true; pl.classList.remove('is-on');
      idleUntil = Date.now() + 1000; nextAt = Math.max(nextAt, idleUntil);
    }
    var swallow = false;
    root.addEventListener('pointerdown', function (e) {
      if (!(opened || (cur && cur.user))) return;
      if (e.target === cv || card.contains(e.target) || sh.contains(e.target) || pl.contains(e.target) || nav.contains(e.target)) return;
      swallow = true; deselect();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur && cur.user) deselect(); });
    function up(e) {
      if (!dragging) return; dragging = false; idleUntil = Math.max(idleUntil, Date.now() + 2000);
      if (mv) return;
      swallow = false;
      var d = hit(e);
      if (d) focusDot(d); else deselect();
    }
    document.addEventListener('pointerdown', function (e) { if (opened && !root.contains(e.target)) closeDetail(); });
    cv.addEventListener('pointerup', up);
    cv.addEventListener('pointercancel', function () { dragging = false; });

    var apiNames = [];
    function fuzzyCity(key) {
      var parts = key.split(','), city = parts[0].trim(), cc = (parts[1] || '').trim(), best = null, bp = -1;
      if (!city) return null;
      apiNames.forEach(function (c) {
        var n = c.name.toLowerCase(), np = n.split(','), nc = np[0].trim(), ncc = (np[1] || '').trim();
        if (cc && ncc !== cc && String(c.country).toLowerCase() !== cc) return;
        if (nc === city || nc.indexOf(city) > -1 || city.indexOf(nc) > -1) { if (c.prints > bp) { bp = c.prints; best = byName[n]; } }
      });
      return best;
    }
    function apply(data) {
      var cities = (data && data.cities) || [];
      apiNames = cities;
      cities.forEach(function (c) {
        if (typeof c.lat !== 'number' || typeof c.lon !== 'number') return;
        var d = snap(c.lon, c.lat); if (!d) return;
        d.c += c.prints;
        if (c.prints > d.top) { d.top = c.prints; d.name = niceName(c.name); d.country = c.country; }
        byName[String(c.name).toLowerCase()] = d; cityCountry[String(c.name).toLowerCase()] = c.country;
      });
      walls.forEach(function (w) {
        var key = String(w.city || '').trim().toLowerCase().replace(/, uk$/, ', gb'), d = byName[key] || fuzzyCity(key);
        if (!d && w.lat !== '' && w.lon !== '' && !isNaN(parseFloat(w.lat)) && !isNaN(parseFloat(w.lon))) { d = snap(parseFloat(w.lon), parseFloat(w.lat)); if (d && !d.hub && w.city) d.name = niceName(w.city); }
        if (!d || !w.img) { if (window.console) console.warn('[ac-globe] mur non placé, ville introuvable ou photo manquante :', w.city); return; }
        (d.walls = d.walls || []).push(w);
        if (!d.c) d.c = 1;
        if (!d.name) d.name = w.city;
        if (!d.country) d.country = countryOf(w.city);
      });
      // Les grosses villes absorbent les points voisins : un seul gros point net au lieu d'un amas
      var all = dots.filter(function (d) { return d.c > 0; }).sort(function (a, b) { return b.c - a.c; });
      thr = Math.max(20, (all.length ? all[0].c : 0) * .12);
      all.sort(function (a, b) { return b.top - a.top || b.c - a.c; });
      all.forEach(function (d) {
        if (d.parent || d.c < thr) return;
        d.hub = true;
        neighbors(d).forEach(function (n) {
          if (!n.c || n.hub || n.parent) return;
          d.c += n.c; n.c = 0; n.parent = d;
          if (n.walls) { d.walls = (d.walls || []).concat(n.walls); n.walls = null; }
        });
      });
      lit = dots.filter(function (d) { return d.c > 0; }).sort(function (a, b) { return a.c - b.c; });
      cMax = lit.length ? lit[lit.length - 1].c : 1;
      dataV++;
      lit.filter(function (d) { return d.hub; }).slice(-14).forEach(function (d) { topSet[d.lon + ',' + d.lat] = 1; });
      // les murs proches d'une grande ville (moins de 150 km) sont rattachés à elle : la visite se pose sur les grandes villes
      var hubs = lit.filter(function (d) { return d.hub; });
      lit.forEach(function (d) {
        if (!d.walls || d.hub) return;
        var best = null, bd = 150 / 6371;
        hubs.forEach(function (h) { var g = arcBetween([d.lon, d.lat], [h.lon, h.lat]).d; if (g < bd) { bd = g; best = h; } });
        if (best) { best.walls = (best.walls || []).concat(d.walls); d.walls = null; }
      });
      entries = [];
      lit.forEach(function (d) { (d.walls || []).forEach(function (w) { entries.push({ w: w, d: d }); preloadThumb(w); }); });
      tourDots = lit.filter(function (d) { return d.walls; });
      live = showLive && data && data.live ? data.live : [];
      if (live.length) { liveEl.hidden = false; nextLive(); }
      ready = true; size();
      if (tourDots.length && autoTour) {
        // on arrive posé sur New York (ou la première ville avec photos), puis on s'envole dès que le bloc est visible
        var d0 = tourDots.filter(function (d) { return /^new york/i.test(d.name || ''); })[0] || tourDots[0];
        var e0 = entries.filter(function (e) { return e.d === d0; })[0];
        if (e0) { history.push(e0); e0.w.__t = Date.now(); remember(e0); }
        cur = { dot: d0, list: d0.walls, i: 0 }; goTo(d0.lon, d0.lat, true); nextAt = Infinity;
      }
      else if (tourDots.length) { var d0 = tourDots[Math.floor(Math.random() * tourDots.length)]; cur = { dot: d0, list: d0.walls, i: 0 }; goTo(d0.lon, d0.lat, true); }
      else goTo(-95, 38, true);
      if ('IntersectionObserver' in window) {
        var io2 = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io2.disconnect(); nextAt = Date.now() + 350;
        }, { threshold: .35 });
        io2.observe(root);
      } else nextAt = Date.now() + 350;
      start();
    }

    size();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { size(); });
    window.addEventListener('resize', function () { var was = mob; size(); if (was !== mob && opened) closeDetail(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (root.__acgVisible) start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { root.__acgVisible = en[0].isIntersecting; if (en[0].isIntersecting && !document.hidden) start(); else stop(); }).observe(root);
    } else root.__acgVisible = true;

    var api = root.getAttribute('data-api');
    if (api) {
      var ctl = window.AbortController ? new AbortController() : null;
      var to = setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
      fetch(api, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); })
        .then(function (d) { clearTimeout(to); apply(d); })
        .catch(function () { clearTimeout(to); apply(null); });
    } else apply(null);
  }

  function boot(el) {
    if (el.__acgInit) return; el.__acgInit = true;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); new Globe(el); } }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else new Globe(el);
  }
  function scan(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ac-globe]'), boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();